import React from 'react';
import { FiFolder } from 'react-icons/fi';
import SidebarElement from '../Elements/SidebarElement';
import { NAV_FILES } from '../navFiles';

const Sidebar = ({
  activeTab = 0,
  onClick = (clickedTab = 0) => console.log(clickedTab),
}) => (
  <aside className="text-muted w-64 h-full border-r border-line bg-page-80">
    <div className="px-3 py-2 text-xs font-mono uppercase tracking-wide text-muted">
      Explorer
    </div>
    <div className="flex items-center gap-2 px-3 py-1.5 text-sm text-ink">
      <FiFolder className="h-4 w-4" aria-hidden="true" />
      <span className="font-mono">portfolio/</span>
    </div>
    <ul className="pl-4 pr-2 pb-4 space-y-0.5">
      {NAV_FILES.map(({ index, filename, Icon }) => (
        <li key={filename}>
          <SidebarElement
            icon={Icon}
            filename={filename}
            isActive={activeTab === index}
            onClick={() => onClick(index)}
          />
        </li>
      ))}
    </ul>
  </aside>
);

export default Sidebar;
